(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/mini/assets/javascripts/collections/total-saved-goals-percent.js') >= 0) return;  svs.modules.push('/components/statistics/mini/assets/javascripts/collections/total-saved-goals-percent.js'); 
(function(svs, _, Backbone) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.collections = svs.components.collections || {};

  var log = new svs.core.log.Logger(
    'svs.components.collections.TotalSavedGoalsPercent'
  );

  svs.components.collections.TotalSavedGoalsPercent = Backbone.Collection.extend(
    {
      url: function() {
        if (!this.teamId || !this.leagueId) {
          log.warn('No teamId or leagueId when trying to fetch.', this);
        }

        return (
          svs.core.jupiter.url() +
          '/sport/1/teams/' +
          this.teamId +
          '/leaguestatistics?leagueid=' +
          this.leagueId
        );
      },

      initialize: function(models, options) {
        options = _.extend({}, options);

        this.teamId = options.teamId || null;
        this.leagueId = options.leagueId || null;
      },

      parse: function(response) {
        if (response.error) {
          log.warn('Error when fetching data.', response);
          return [];
        }

        var percent = this.getParsedTotalSavedGoalsPercent(response);
        var players = this.getParsedPlayers(response);

        return this.extendPercentagesWithPlayer(percent, players);
      },

      getParsedTotalSavedGoalsPercent: function(response) {
        if (
          svs.utils.ns.isNamespace(
            'teamStatistics.playerStatistics.byKey.totalSavedGoalsPercent',
            response
          )
        ) {
          return response.teamStatistics.playerStatistics.byKey
            .totalSavedGoalsPercent;
        }
        return []; 
      },

      getParsedPlayers: function(response) {
        if (
          svs.utils.ns.isNamespace(
            'teamStatistics.playerStatistics.players',
            response
          )
        ) {
          return response.teamStatistics.playerStatistics.players;
        }
        return []; 
      },

      extendPercentagesWithPlayer: function(percent, players) {
        _.each(
          percent,
          function(goalie) {
            var players = this;
            goalie.player = _.findWhere(players, { id: goalie.playerId });
          },
          players
        );

        return percent;
      },

      getPercentForPlayerId: function(playerId, options) {
        options = _.extend(
          {
            numberOfDecimals: 2,
            returnNumber: false
          },
          options
        );

        var player = this.findWhere({
          playerId: playerId
        });

        if (player) {
          var value = player.get('value');

          return svs.utils.format.getPercentageFromDecimalPercentage(
            value,
            options
          );
        }
        return '';
      },

      setLeagueId: function(leagueId) {
        this.leagueId = leagueId;
      },

      setTeamId: function(teamId) {
        this.teamId = teamId;
      },

      isEmpty: function() {
        return this.length === 0;
      },

      toJSON: function(options) {
        options = _.extend(
          {
            round: true
          },
          options
        );

        if (options.round) {
          var json = [];

          this.each(function(player) {
            json.push({
              player: player.get('player'),
              value: this.getPercentForPlayerId(player.get('playerId'))
            });
          }, this);

          return json;
        }
        return Backbone.Collection.prototype.toJSON.call(this, options);
      }
    }
  );
})(svs, _, Backbone);

 })(window);